export default __webpack_public_path__ + "static/media/production.f66eff0e.jpg";